import * as tslib_1 from "tslib";
import { store } from "store";
import { Vue, Component } from "vue-property-decorator";
import "../components/KkGenericPopup";
import axios from "axios";
import xamatron from "xamatron";
var InvitePreviousSponsorsView = /** @class */ (function (_super) {
    tslib_1.__extends(InvitePreviousSponsorsView, _super);
    function InvitePreviousSponsorsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.loading = true;
        _this.error = null;
        _this.popupVisible = false;
        _this.sendStatus = null;
        _this.sponsors = [];
        _this.sponsorsByOrg = {};
        _this.selectedSponsorIds = [];
        _this.numSponsors = 0;
        return _this;
    }
    InvitePreviousSponsorsView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, previousSponsors, _b, _c, s;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, axios.get("sponsors/previous-sponsors")];
                    case 1:
                        previousSponsors = (_d.sent()).data;
                        // Don't include sponsors that are already on user's sponsor list
                        this.sponsors = previousSponsors
                            .filter(function (s) {
                            return !store.selectedEvent.sponsors.some(function (sp) { return sp.sponsorId === s.sponsor.sponsorId || sp.email === s.sponsor.email; });
                        });
                        try {
                            // group sponsors by organizationId
                            for (_b = tslib_1.__values(this.sponsors), _c = _b.next(); !_c.done; _c = _b.next()) {
                                s = _c.value;
                                if (this.sponsorsByOrg[s.organizationId])
                                    this.sponsorsByOrg[s.organizationId].push(s);
                                else
                                    this.sponsorsByOrg[s.organizationId] = [s];
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(InvitePreviousSponsorsView.prototype, "allSelected", {
        get: function () {
            return this.selectedSponsorIds.length === this.sponsors.length;
        },
        enumerable: true,
        configurable: true
    });
    InvitePreviousSponsorsView.prototype.toggleAll = function () {
        var _this = this;
        var all = this.allSelected;
        this.selectedSponsorIds.splice(0);
        if (!all) {
            for (var s in this.sponsorsByOrg)
                this.sponsorsByOrg[s].forEach(function (s) { return _this.selectedSponsorIds.push(s.sponsor.sponsorId); });
        }
    };
    InvitePreviousSponsorsView.prototype.emailInput = function (sponsor, e) {
        sponsor.editingEmail = true;
    };
    InvitePreviousSponsorsView.prototype.sendInvitations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectedSponsors, emails, e_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sendStatus = "Sending";
                        selectedSponsors = this.sponsors
                            .filter(function (s) { return s.sponsor.email && _this.selectedSponsorIds.some(function (id) { return id === s.sponsor.sponsorId; }); })
                            .map(function (s) { return s.sponsor; });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        emails = selectedSponsors.map(function (s) { return s.email.trim(); });
                        return [4 /*yield*/, axios.post("sponsors/invite-email", { eventId: this.store.selectedEvent.eventId, emails: emails })];
                    case 2:
                        _a.sent();
                        this.$set(store.selectedEvent, "sponsors", store.selectedEvent.sponsors.concat(selectedSponsors));
                        this.sendStatus = "Sent";
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.error = e_2.message;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    InvitePreviousSponsorsView.prototype.infoPopup = function () {
        this.popupVisible = true;
    };
    InvitePreviousSponsorsView.prototype.closePopup = function () {
        this.popupVisible = false;
    };
    InvitePreviousSponsorsView.prototype.goToAddSponsor = function () {
        this.$router.push("/add-sponsor");
    };
    InvitePreviousSponsorsView.prototype.goToContacts = function () {
        xamatron.openURL(this.root.getSiteUrl("public/fororganizations"));
    };
    InvitePreviousSponsorsView = tslib_1.__decorate([
        Component
    ], InvitePreviousSponsorsView);
    return InvitePreviousSponsorsView;
}(Vue));
export default InvitePreviousSponsorsView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/InvitePreviousSponsorsView.vue
// module id = 63
// module chunks = 0